exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".title___2mVC6 {\n  text-align: center;\n  height: 227px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: end;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 80%;\n  margin: auto;\n  font-size: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"title": "title___2mVC6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/Warn.css
// module id = 814
// module chunks = 2